/**
 * Draft / Posted documents that move petty cash or trip money — expense settlements (#5799) and employee advances
 * (#5789). Both enums share the values, so one label and severity serve them.
 */
export enum CashDocumentStatus {
  Draft = 1,
  Posted = 2,
}

export function cashDocumentStatusLabel(status: number, t: (key: string, fallback: string) => string): string {
  switch (status) {
    case CashDocumentStatus.Draft:
      return t('CashDocument_Status_Draft', 'Draft');
    case CashDocumentStatus.Posted:
      return t('CashDocument_Status_Posted', 'Posted');
    default:
      return '';
  }
}

export function cashDocumentStatusSeverity(status: number): 'success' | 'warn' | 'secondary' {
  switch (status) {
    case CashDocumentStatus.Draft:
      return 'warn';
    case CashDocumentStatus.Posted:
      return 'success';
    default:
      return 'secondary';
  }
}

export const CASH_DOCUMENT_STATUSES: CashDocumentStatus[] = [CashDocumentStatus.Draft, CashDocumentStatus.Posted];
